import { EPhoneErrorMessages } from '../constants';

export const isPhoneValid = (phone: string): boolean => /^\+\d\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}$/.test(phone);

export const phoneValidator = (required: boolean) => (value: unknown) => {
  if (!value) {
    return required ? EPhoneErrorMessages.Required : null;
  }

  if (!isPhoneValid(String(value))) {
    return EPhoneErrorMessages.Format;
  }

  return null;
};
